import React, { useEffect, useState } from "react";
import "./Product_info.css";
import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";
import Demo_Product from "../../home/demo_product/Demo_Product";
import Increment_decrement_btn_holder from "../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder";
import { useNavigate } from "react-router-dom";
import Rating from "react-rating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategories } from "../../../features/master/masterSlice";
import { getHomeBanner } from "../../../features/home/homeSlice";
import { postCart } from "../../../features/cart/cartSlice";
import Demo_ProductCategory from "../../home/demo_product/Demo_ProductCategory";
import { RolesIds, variant_type } from "../../../utils/common";
import Best_seller_heart from "../../common-components/product_card/Best_seller_heart/Best_seller_heart";
import parse from "html-react-parser";
import Increment_decrement_btn_holder_add from "../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder_add";
import Brown_btn from "../../common-components/common_btn/brown_btn/Brown_btn";
import Add_to_card_btn from "../../common-components/common_btn/Add_to_card_btn/Add_to_card_btn";
import Success_Modal from "../../common-components/common_modal/success_modal/Success_Modal";
import Set_New_Password_Modal from "../../common-components/common_modal/set_new_password_modal/Set_New_Password_Modal";
import Reset_Password_Modal from "../../common-components/common_modal/reset_password_modal/Reset_Password_Modal";
import Login_Modal from "../../common-components/common_modal/login_modal/Login_Modal";

const Product_info = ({
  selectedVariant,
  setSelectedVariant,
  activeSize,
  activeTriple,
  activeMetal,
  setActiveTriple,
  setActiveSize,
  setActiveMetal,
  product,
  avg_rating,
}) => {
  const [activeIndex, setActiveIndex] = useState(0); // default first card active
  const [activeIndex2, setActiveIndex2] = useState(0); // default first card active

  const [email, setEmail] = useState();
  const [contact, setContact] = useState();

  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [showAccountCreted, setShowAccountCreted] = useState(false);
  const [error, setError] = useState("");
  const isSignIn = useSelector((state) => state.auth.is_signin);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const user = useSelector((state) => state.myaccount.addMyaccount);

  const navigate = useNavigate();

  const handleClickAdd = () => {
    navigate(`/product-cart`);
  };
  const handleClick = () => {
    if (isSignIn) {
      navigate(`/proceed-to-Checkout`);
    } else {
      setShowLoginModal(true);
    }
  };

  useEffect(() => {
    if (user?.role_id && Number(user?.role_id) === RolesIds.Vendor) {
      setQuantity(selectedVariant?.b2b_min_quanity || 1);
    }
  }, [selectedVariant]);

  const dispatch = useDispatch();

  const [quantity, setQuantity] = useState(1);

  const addToCart = async (type) => {
    try {
      const data = {
        product_id: product.id,
        variant_type_id: product.variant_type_id,

        // variant_id: selectedVariant?.id,
        quantity: quantity,
      };
      if (Number(product.variant_type_id) === variant_type.Single) {
        data.variant_id = selectedVariant?.id;
      } else if (Number(product.variant_type_id) === variant_type.Double) {
        data.d_variant_id = selectedVariant?.id;
      } else if (Number(product.variant_type_id) === variant_type.Triple) {
        data.t_variant_id = selectedVariant?.id;
      }
      const res = await dispatch(postCart({ data: data, isSignIn: isSignIn }));
      console.log({ resresres: res });

      if (res.meta?.requestStatus === "fulfilled") {
        if (type === "add_cart") {
          handleClickAdd();
        } else {
          handleClick();
        }
        if (res?.payload?.data?.success) {
        } else {
        }
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  // Auto select first available variant
  useEffect(() => {
    if (activeMetal?.Double_Variants?.length > 0) {
      setSelectedVariant(activeMetal?.Double_Variants?.[0]);
      setActiveSize(activeMetal?.Double_Variants?.[0]);
    }
  }, [activeMetal]);

  useEffect(() => {
    if (setActiveSize?.Triple_Variants?.length > 0) {
      setSelectedVariant(setActiveSize?.Triple_Variants?.[0]);
      setActiveTriple(setActiveSize?.Triple_Variants?.[0]);
    }
  }, [setActiveSize]);

  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "₹";

  const val = {
    quantity: 1,
  };

  const isVendor = user?.role_id && Number(user?.role_id) === RolesIds.Vendor;

  return (
    <section className="Product_info">
      <div className="text_holder">
        <p className="cat_name">{product?.p_category?.name}</p>

        <div className="top_div">
          <h4 className="">{product?.name}</h4>
          <div className="wishlist_div">
            <Best_seller_heart product={product} />
          </div>
        </div>

        <div className="two_container">
          {selectedVariant && (
            <div className="price_holder">
              {isVendor ? (
                <h6 className="">
                  {symbol}{" "}
                  {Number(selectedVariant?.b2b_price * rate).toFixed(2)}
                  {/* <span className="discounted_price">
                    {symbol} {Number(selectedVariant.mrp * rate).toFixed(2)}
                  </span> */}
                </h6>
              ) : (
                <h6 className="">
                  {symbol} {Number(selectedVariant.price * rate).toFixed(2)}
                  <span className="discounted_price">
                    {symbol} {Number(selectedVariant.mrp * rate).toFixed(2)}
                  </span>
                </h6>
              )}
              {/* discount */}
              {/* <div className="save_div">
              <Green_btn
                btnText={`Save: ${Math.round(
                  ((selectedVariant.mrp * rate - selectedVariant.price * rate) /
                    (selectedVariant.mrp * rate)) *
                    100,
                ) || 0}%`}
              />
            </div> */}

              {/* <span className="mrp_holder">MRP (Inclusive of all taxes)</span> */}
            </div>
          )}

          <div className="rating_holder">
            <p className="rating_text ">
              <Rating
                className="star_icons "
                initialRating={Number(avg_rating?.average_rating)}
                emptySymbol={<FontAwesomeIcon icon={farStar} color="#fff" />}
                fullSymbol={<FontAwesomeIcon icon={fasStar} color="#fff" />}
                fractions={2}
                readonly
              />
              ( {avg_rating?.total_counts} Reviews)
            </p>
          </div>
        </div>

        <p className="descn_text">
          {typeof product?.description === "string"
            ? parse(product.description)
            : null}
        </p>
      </div>

      <div>
        {/* METAL */}

        <div className="quantity_holder">
          <p className="type_text">Size</p>
          <div className="d-flex flex-wrap">
            {product?.Product_Variants?.map((option) => (
              <div className="me-1" key={option.id}>
                <div
                  className={`quantity_box_holder ${
                    Number(option?.general_stock) <= 0
                      ? "prodnotavailable"
                      : activeMetal?.id === option.id
                      ? "active"
                      : ""
                  }`}
                  // className={`quantity_box_holder prodnotavailable ${activeMetal?.id === option.id ? "active" : ""
                  //   }`}
                  onClick={() => {
                    setActiveMetal(option);
                    if (product?.variant_type_id === variant_type.Single) {
                      setSelectedVariant(option);
                    }
                  }}
                >
                  <div className="info_holder">
                    <h5>{option?.Metal?.name}</h5>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* <br></br> */}

        {/* SIZE (Double Variants) */}
        {/* {product?.Product_Variants?.find((v) => v.id === activeMetal?.id)
          ?.Double_Variants?.length > 0 && (
          <div className="quantity_holder">
            <p className="type_text">Size</p>
            <div className="d-flex flex-wrap">
              {product.Product_Variants.find(
                (v) => v.id === activeMetal?.id,
              ).Double_Variants.map((item) => (
                <div className="sizebox mb-3 me-2" key={item.id}>
                  <div
                    className={`quantity_box_holder ${
                      activeSize?.id === item.id ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveSize(item);
                      // setActiveTriple(null);
                      if (product?.variant_type_id === variant_type.Double) {
                        setSelectedVariant(item);
                      }
                    }}
                  >
                    <div className="info_holder">
                      <h5>{item?.Size?.name}</h5>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )} */}

        {/* <p>
          <strong>Measurement</strong> : {product?.measurements}{" "}
        </p> */}

        {product?.Product_Variants?.find(
          (v) => v.id === activeMetal?.id,
        )?.Double_Variants?.find((s) => s.id === activeSize?.id)
          ?.Triple_Variants?.length > 0 &&
          Number(product?.variant_type_id) === Number(variant_type.Triple) && (
            <div className="quantity_holder">
              <p className="type_text">Diamond</p>
              <div className="row">
                {product.Product_Variants.find((v) => v.id === activeMetal?.id)
                  .Double_Variants.find((s) => s.id === activeSize?.id)
                  .Triple_Variants.map((item1) => (
                    <div className="col-sm-3 col-6 mb-3" key={item1.id}>
                      <div
                        className={`quantity_box_holder ${
                          activeTriple?.id === item1.id ? "active" : ""
                        }`}
                        onClick={() => {
                          setActiveTriple(item1);
                          if (
                            product?.variant_type_id === variant_type.Triple
                          ) {
                            setSelectedVariant(item1);
                          }
                        }}
                      >
                        <div className="info_holder">
                          <h5>{item1?.Diamond?.name}</h5>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
      </div>

      <div className="prod_description"> </div>
      {isVendor && (
        <p>
          <strong>Note </strong> : Minimum Quantity For this variant is{" "}
          {selectedVariant?.b2b_min_quanity || 1}{" "}
        </p>
      )}
      <div className="btn_holder">
        {selectedVariant?.general_stock <= 0 ? (
          <Brown_btn btnText="Out of Stock" disabled />
        ) : (
          <>
            <Increment_decrement_btn_holder
              quantity={quantity}
              setQuantity={setQuantity}
              isVendor={isVendor}
              general_stock={selectedVariant?.general_stock || 0}
              b2b_min_quanity={selectedVariant?.b2b_min_quanity || 1}
            />

            <div className="add_cart_btn">
              <Green_btn
                btnText="Add to Cart"
                product={product}
                onClick={() => addToCart("add_cart")}
                quantity={quantity}
                setQuantity={setQuantity}
                selectedVariant={selectedVariant}
              />
            </div>

            <div className="buy_now">
              <Brown_btn
                btnText="Buy Now"
                onClick={() => addToCart("buy_now")}

                // onClick={() => navigate("/proceed-to-Checkout")}
              />
            </div>
          </>
        )}
      </div>

      <Login_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showLoginModal}
        onHide={() => {
          setShowLoginModal(false);
        }}
        setShowResetModal={() => setShowResetModal(true)}
        setShowAccountCreted={() => setShowAccountCreted(true)}
      />

      <Reset_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showResetModal}
        onHide={() => {
          setShowResetModal(false);
        }}
        setShowSetPassModal={() => setShowSetPassModal(true)}
      />

      <Set_New_Password_Modal
        show={showSetPassModal}
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        onHide={() => {
          setShowSetPassModal(false);
        }}
        setShowSucsessModal={() => setShowSucsessModal(true)}
      />

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="Password Reseted Successfully!"
      />

      <Success_Modal
        show={showAccountCreted}
        onHide={() => {
          setShowAccountCreted(false);
        }}
        successText="Account Created Successful!"
      />
    </section>
  );
};

export default Product_info;
